import { LOAD_PERMISSION, PermissionActionTypes, PermissionState } from './types';

export function updatePermission(newSystem: PermissionState): PermissionActionTypes {
  return {
    type: LOAD_PERMISSION,
    payload: newSystem
  };
}
